import { local } from 'shared/utils/storage/local-storage';
import { localStorageItems } from './constants/localStorage';

export const isUsingMock =
  import.meta.env.PUBLIC_LOAD_MSW === String(true) &&
  local.get(localStorageItems.enableMsw) === true;
